import CodeBlock from '../CodeBlock';

export default function DocsQuickStart() {
  return (
    <section data-docs-section="quickstart" className="text-left mb-16">
      <h2 className="text-2xl font-bold text-white mb-2 group">
        <a href="#quickstart" className="hover:text-sky-400 transition-colors">Quick Start</a>
        <span className="ml-2 opacity-0 group-hover:opacity-100 text-gray-600 transition-opacity">#</span>
      </h2>
      <p className="text-gray-400 mb-4">
        Full workflow in 10 lines — fetch data, generate a signal, backtest it,
        and render a tearsheet.
      </p>

      <CodeBlock
        code={`import propalgos as pa

# 1. Fetch price data
prices = pa.data.prices("AAPL", start="2020-01-01")

# 2. Generate a trading signal
signal = pa.signals.sma_cross(prices, fast=20, slow=100)

# 3. Run backtest with transaction costs
result = pa.backtest.run(prices, signal, fee_bps=5.0, benchmark="SPY")

# 4. View the tearsheet
pa.viz.tearsheet(result)

# 5. Print summary metrics
print(result.summary())`}
        filename="quickstart.py"
      />

      <p className="text-sm text-gray-500 mt-4">
        The signal is a Series of <code className="text-gray-400">{'{-1, 0, 1}'}</code> — long, flat, or short.
        The backtest engine applies next-bar execution (no look-ahead bias), deducts costs,
        and computes a full metrics suite including Sharpe, Sortino, max drawdown, and more.
      </p>
    </section>
  );
}
